import NotificationSocket from './socket';

const socketClient = new NotificationSocket();

export default socketClient;
